import { Middleware, MiddlewareApi } from '../index';
import { FilterType } from './action';
import { Filter } from '../../Enum/Filters';
import { labelSelected } from '../Label/action';
import { Label } from '../../Interface/Response/Interest/Label';

export class FilterMiddleware {
    public middleware: Middleware = store => next => action => {
        next(action);

        const label = store.getState().filter.filterValues[Filter.Label];

        if (
            action.type === FilterType.filterIsSubmitted &&
            label &&
            label !== store.getState().label.activeLabel?.findataCode
        ) {
            return this.updateActiveLabel(store);
        }
    };

    private async updateActiveLabel(store: MiddlewareApi): Promise<void> {
        store.dispatch(
            labelSelected(
                store
                    .getState()
                    .label.labels.find(
                        ({ findataCode }) => findataCode === store.getState().filter.filterValues[Filter.Label],
                    ) as Label,
            ),
        );
    }
}
